import { app } from '../../../../../../app';
import { Controller } from './auto-configure-sso.controller';

app.component('autoConfigureSsoModal', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./auto-configure-sso.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/configure-sso/auto-configure-sso/auto-configure-sso.component.js